import { FinanceAccountListDetailContainer } from '../../../containers';

export const FinanceAccountListDetail = () => {
  return <FinanceAccountListDetailContainer />;
};
